import { render, staticRenderFns } from "./VSubjectProperty.vue?vue&type=template&id=41af358a"
import script from "./VSubjectProperty.vue?vue&type=script&lang=js"
export * from "./VSubjectProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports